import { Action, TrendsState } from "../types"
import { TRENDS_ACTION } from "../actions/trendsActions"

export default (state = new TrendsState(), action: Action): TrendsState => {
  switch (action.type) {
    case TRENDS_ACTION.FETCH_FILTER_OPTIONS:
      return { ...state, options: action.payload }
    case TRENDS_ACTION.FETCH_STREAMS_DAILY:
      return { ...state, streamsDaily: action.payload }
    case TRENDS_ACTION.FETCH_STREAMS_COUNTRY:
      return { ...state, streamsCountry: action.payload }
    case TRENDS_ACTION.FETCH_STREAMS_DEMOGRAPHIC:
      return { ...state, streamsDemographic: action.payload }
    case TRENDS_ACTION.FETCH_TREND_TOP_TRACKS:
      return { ...state, trendTopTracks: action.payload }
    case TRENDS_ACTION.FETCH_STREAMS_TRACK_MONTHS:
      return { ...state, artistTrendEconomyData: action.payload }
    case TRENDS_ACTION.FETCH_ARTIST_TREND_ECONOMIES:
      return { ...state, artistTrendEconomyData: action.payload }
    default:
      return state
  }
}
